import {forgotPass2} from 'backend/auth';
import wixLocation from 'wix-location';
import {local} from 'wix-storage';
import {login} from 'backend/auth';

$w.onReady(function() {

});

function newPass(newPassword, reNewPassword) {
    if (local.getItem('forgotPass')) {
        let email = local.getItem('forgotPass');
        console.log('Email: ', email);
        if (newPassword && newPassword) {
            if (newPassword === reNewPassword) {
                if (newPassword.length >= 6) {
                    $w('#forwardBtn').collapse();
                    $w('#loading').expand();
                    forgotPass2(email, newPassword, reNewPassword).then(response => {
                        if (response.error) {
                            throw new Error(response.error.message);
                        }
                    }).catch(error => {
                        $w('#loading').collapse();
                        $w('#forwardBtn').expand();
                        console.log(error)
                    });

                    login(email, newPassword).then((response) => {
                        //console.log(response);
                        if (response.error) {
                            throw new Error(response.error.message);
                        }

                        let user = JSON.stringify(response);
                        console.log(user);
                        local.setItem("user", user);
                        local.removeItem('forgotPass');
                        if (response.InitText || Number(response.Level) > 1) {
                            wixLocation.to('/lp-home2');
                        } else {
                            wixLocation.to('/lp-registration-caseinfo');
                        }
                    }).catch(error => {
                        $w('#loading').collapse();
                        $w('#forwardBtn').expand();

                        switch (error.message) {
                            case 'INVALID_PASSWORD':
                                $w('#error').text = 'Невалидна парола!'
                                $w('#error').expand();
                                break;

                            case 'EMAIL_NOT_FOUND':
                                $w('#error').text = 'Невалиден имейл!'
                                $w('#error').expand();
                                break;
                        }
                    });
                } else {
                    $w('#error').text = 'Паролата трябва да е поне 6 символа!';
                    $w('#error').expand();
                }
            } else {
                $w('#error').text = 'Паролите не съвпадат!';
                $w('#error').expand();
            }

        } else {
            $w('#error').text = 'Моля попълнете всички полета!';
            $w('#error').expand();
        }
    } else {
        wixLocation.to('/lp-login');
    }
}

export async function forwardBtn_click(event) {
    let newPassword = $w('#newPassword').value;
    let reNewPassword = $w('#reNewPassword').value;

    newPass(newPassword, reNewPassword);
}

export async function reNewPassword_keyPress(event) {
    if (event.key === 'Enter') {
        let newPassword = $w('#newPassword').value;
        let reNewPassword = $w('#reNewPassword').value;

        newPass(newPassword, reNewPassword);
    }
}